import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const TerreoPagina = () => {
  return (
    <div className="terreo-container">
      <h1>Controle de Iluminação - Térreo</h1>
      <GroupLightComponent
        groupIds={["grupo01", "grupo02", "grupo03", "grupo04", "grupo05" ,"grupo06", 
          "grupo07", "grupo08", "grupo09", "grupo10", "grupo11", "grupo12", "grupo41","grupo42","grupo44"
          ]}
        pageId="2"
      />
    </div>
  );
};

export default TerreoPagina;